export default "__VITE_ASSET__BYhPOca5__"